/**
 * @description 將圖片檔案(Blob)轉換為預覽的Url
 *
 * @param file 檔案 Blob
 * @returns 預覽圖片 url
 */
export function getImagePreviewSrcByBlob(file: Blob): string {
  return (window.URL ? URL : webkitURL).createObjectURL(file);
}
